import { initializeApp } from 'firebase/app';
import { getAnalytics, setAnalyticsCollectionEnabled, setUserProperties } from 'firebase/analytics';

// Your web app's Firebase configuration
// Vite uses import.meta.env.VITE_* for environment variables
const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Disable analytics by default until consent is given
setAnalyticsCollectionEnabled(analytics, false);

const initializeAnalytics = () => {
  const consent = localStorage.getItem('cookie-consent');

  if (consent === 'accepted') {
    setAnalyticsCollectionEnabled(analytics, true);
    setUserProperties(analytics, {
      user_type: 'website_visitor',
      initial_landing_page: window.location.pathname,
      referrer: document.referrer || 'direct',
      viewport_size: `${window.innerWidth}x${window.innerHeight}`,
      platform: navigator.platform
    });
  } else {
    setAnalyticsCollectionEnabled(analytics, false);
  }
};

export { analytics, initializeAnalytics };
